<template>
    <div>
        <el-form :inline="true" ref="form">
            <el-form-item label="运营人员：" class="query-form-item">
                <el-select v-model="query.operation_id" placeholder="状态" size="mini" style="width: 100px;">
                    <el-option label="全部" value=""></el-option>
                    <el-option :label="item.full_name" :value="item.id"
                               v-for="item in managerAnalysisList"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="ID:" class="query-form-item">
                <el-input style="width: 100px;" clearable v-model="query.id" placeholder="请输入ID"
                          size="mini"></el-input>
            </el-form-item>

            <el-form-item label="国家" prop="state">
                <el-select v-model="query.state" style="width: 120px;" size="mini" filterable>
                    <el-option
                            v-for="item in $common.us_arr"
                            :key="item.us"
                            :label="item.title"
                            :value="item.us"
                            :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="ASIN：" class="query-form-item">
                <el-input style="width: 150px;" clearable v-model="query.asin" placeholder="请输入ASIN"
                          size="mini"></el-input>
            </el-form-item>

            <el-form-item label="父ASIN：" class="query-form-item">
                <el-input style="width: 150px;" clearable v-model="query.parent_asin" placeholder="请输入父ASIN"
                          size="mini"></el-input>
            </el-form-item>

            <el-form-item label="品名:" class="query-form-item">
                <el-input style="width: 120px;" clearable v-model="query.product_name" placeholder="请输入品名"
                          size="mini"></el-input>
            </el-form-item>

            <el-form-item label="是否有专利值:" class="query-form-item">
                <el-select v-model="query.has_patent_value" placeholder="状态" size="mini" style="width: 100px;">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="有" :value="1"></el-option>
                    <el-option label="没有" :value="0"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="标品类型：" class="query-form-item">
                <el-select v-model="query.standard_product_type" placeholder="标品类型" size="mini"
                           style="width: 120px">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="未录入" :value="-1"></el-option>
                    <el-option :label="item.name" :value="item.value"
                               v-for="item in standardProductTypeArr"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="选品原则：" class="query-form-item">
                <el-select v-model="query.selection_principle" placeholder="选品原则" size="mini" style="width: 120px">
                    <el-option label="全部" value=""></el-option>
                    <el-option :label="item.name" :value="item.value"
                               v-for="item in selectionPrincipleList"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="是否季节性：" class="query-form-item">
                <el-select v-model="query.is_seasonality" placeholder="季节性" size="mini" style="width: 100px;">
                    <el-option label="全部" :value="undefined"></el-option>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="季节：" class="query-form-item">
                <el-select v-model="query.season" placeholder="请选择" size="mini" filterable style="width: 100px;">
                    <el-option :label="item.label" :value="item.value"
                               v-for="item in $common.seasonArr"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="FBA费用是否核对：" class="query-form-item">
                <el-select v-model="query.check_fba_charge" size="mini" style="width: 100px;">
                    <el-option :label="item.name" :value="item.value"
                               v-for="item in fbaCollateArr"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="是否主卖：" class="query-form-item">
                <el-select v-model="query.is_main_seller" placeholder="是否主卖" size="mini" style="width: 100px;">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="未核对" :value="-1"></el-option>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="包装核对：" class="query-form-item">
                <el-select v-model="query.check_packing" placeholder="包装核对" size="mini" style="width: 100px;">
                    <el-option :label="item.name" :value="item.value"
                               v-for="item in collateArr"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="价格核对：" class="query-form-item">
                <el-select v-model="query.is_market_lowest_price" placeholder="价格核对" size="mini"
                           style="width: 100px;">
                    <el-option :label="item.name" :value="item.value"
                               v-for="item in isLowPrice"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="vine情况：" class="query-form-item">
                <el-select v-model="query.vine_status" placeholder="vine情况" size="mini" style="width: 100px;">
                    <el-option :label="item.name" :value="item.value"
                               v-for="item in vineStatusArr"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="是否有广告组：" class="query-form-item">
                <el-select v-model="query.had_ad_groups" placeholder="请选择" size="mini" style="width: 100px;">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="价格：">
                <el-input-number style="width: 150px;" clearable v-model="query.min_price" placeholder="最小"
                                 :min="0" :step="0.01" size="mini"></el-input-number>
                -
                <el-input-number style="width: 150px;" clearable v-model="query.max_price" placeholder="最大"
                                 :min="0" :step="0.01" size="mini"></el-input-number>
            </el-form-item>

            <form-range-item :queryTemp="query" ref="formRangeItem"></form-range-item>

            <el-form-item label="FBA可售数量:" class="query-form-item">
                <el-input-number style="width: 130px;" clearable v-model="query.min_fba_sale_quantity"
                                 placeholder="最小" size="mini" :step="1" :min="0"></el-input-number>
                -
                <el-input-number style="width: 130px;" clearable v-model="query.max_fba_sale_quantity"
                                 placeholder="最大" size="mini" :step="1" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="小类排名:" class="query-form-item">
                <el-input-number style="width: 130px;" clearable v-model="query.min_small_category_rank"
                                 placeholder="最小" size="mini" :step="1" :min="0"></el-input-number>
                -
                <el-input-number style="width: 130px;" clearable v-model="query.max_small_category_rank"
                                 placeholder="最大" size="mini" :step="1" :min="0"></el-input-number>
            </el-form-item>

            <el-form-item label="Teambition状态：" class="query-form-item">
                <el-select v-model="query.tfs_name" placeholder="请选择" size="mini" filterable style="width: 120px">
                    <el-option label="全部" value=""></el-option>
                    <el-option :label="key" :value="key" v-for="(key, value) in teambitionList"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="小爆款：" class="query-form-item">
                <el-select v-model="query.is_small_bestseller" placeholder="请选择" size="mini" filterable
                           style="width: 110px;">
                    <el-option label="全部" value=""></el-option>
                    <el-option :label="item.name" :value="item.value" v-for="item in smallBestseller"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="评分范围:">
                <el-input-number style="width: 150px;" clearable v-model="query.min_rating"
                                 placeholder="最小评分" :min="0" :step="1" size="mini"></el-input-number>
                -
                <el-input-number style="width: 150px;" clearable v-model="query.max_rating"
                                 placeholder="最大评分" :min="0" :step="1" size="mini"></el-input-number>
            </el-form-item>

            <el-form-item label="">
                <el-checkbox v-model="query.null_rating" @change="changeNullRating">暂无评分</el-checkbox>
            </el-form-item>

            <el-form-item label="Teambition是否核对：" class="query-form-item">
                <el-select v-model="query.had_collate_teambition" placeholder="请选择" size="mini" filterable
                           style="width: 110px;">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Best Seller：" class="query-form-item">
                <el-select v-model="query.had_bsr" placeholder="" size="mini" style="width: 100px;">
                    <el-option label="全部" :value="undefined"></el-option>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                </el-select>
            </el-form-item>

            <el-button type="primary" @click="onSubmit" size="mini" style="margin-top: 5px">查询</el-button>
            <el-button type="success" size="mini" @click="exportFunc()">导出</el-button>
            <el-button type="success" size="mini" @click="autoOptimize" v-show="showDistributionPeople">Acos优化
            </el-button>

        </el-form>
        <el-table v-loading="loading" :data="list" :height="tableHeight" size="mini" ref="multipleTable"
                  @row-click="clickRowHandle" @header-click="clickHeaderHandle"
                  class="table_content mini_div" border @sort-change="handleSortChange" style="width: 100%;">
            <el-table-column label="ID" width="60" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>

            <el-table-column label="图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.operator_asin_img_url">
                        <img style="width:90px;height:90px;" src="../../assets/image/noPic.png"/>
                    </div>
                    <img style="width:90px;height:90px;" :src="scope.row.operator_asin_img_url" v-else/>
                </template>
            </el-table-column>

            <el-table-column label="Asin" width="180" align="center">
                <template slot-scope="scope">
                    <div class="asinBox">
                        <icon-svg
                                :icon-class="(scope.row.state || '').toUpperCase()"
                                style="font-size: 24px;margin-left:5px;"
                        ></icon-svg>
                        <span @click="jumpAmazonByState(scope.row)"
                              style="color: blue;cursor: pointer">{{ scope.row.asin }}</span>

                        <div class="hotBox">
                            <el-tooltip class="item" effect="dark" placement="top">
                                <div slot="content">
                                    生成时间: {{scope.row.small_bestseller_time}}<br/>
                                    核对时间: {{scope.row.small_bestseller_collate_time}}<br/>
                                </div>
                                <span>
                                    <img src="@/assets/hot.png" style="width:12px;height:12px;display: inline-block" v-show="[1,2].includes(scope.row.is_small_bestseller)"/>
                                    <span v-show="scope.row.is_small_bestseller === 1">爆-自然</span>
                                    <span v-show="scope.row.is_small_bestseller === 2">爆-低Acos</span>
                                </span>
                            </el-tooltip>
                        </div>

                        <div
                                class="no-finish-box"
                                :style="{
                                    color: ((scope.row.no_finish_teambition_remind || []).length > 0 ? 'red' : 'black'),
                                    'font-weight': ((scope.row.no_finish_teambition_remind || []).length > 0 ? '700' : '400'),
                                    cursor: ((scope.row.no_finish_teambition_remind || []).length > 0 ? 'pointer' : 'default')
                                }"
                                @click.stop.prevent="(scope.row.no_finish_teambition_remind || []).length > 0 && openNoFinishDialog(scope.row.no_finish_teambition_remind)"
                        >
                            未完成任务：{{ (scope.row.no_finish_teambition_remind || []).length || 0 }}
                        </div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column width="110" align="center" label="父asin">
                <template slot-scope="scope">
                    <span>{{ scope.row.parent_asin }}</span>
                </template>
            </el-table-column>

            <el-table-column label="负责人" width="150" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.operation_username }} <br/>
                        {{ scope.row.operation_full_name }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="基础信息" width="400" align="center">
                <template slot-scope="scope">
                    <div style="text-align: left">
                        <div style="font-size: 16px; font-weight: 600;">{{ scope.row.title }}</div>
                        <div style="display: flex" v-show="scope.row.rating">
                            <el-rate
                                    v-model="scope.row.ratingNum"
                                    disabled
                                    text-color="#ff9900"
                            >
                            </el-rate>
                            <div style="color: rgb(247, 186, 42)">{{ scope.row.rating }}</div>
                        </div>
                        <div style="font-size: 15px; font-weight: 600;">{{ scope.row.price }}</div>
                        <div style="font-size: 12px; font-weight: 600;">
                            更新时间：{{ scope.row.last_keepa_update_time }}
                        </div>
                        <div style="font-size: 12px; font-weight: 600;">品牌：{{ scope.row.brand }}</div>
                        <div style="font-size: 12px; font-weight: 600;">评论数：{{ scope.row.rating_count }}</div>
                        <div style="font-size: 12px; font-weight: 600;" v-show="scope.row.bsr">
                            <span class="redBox">#1 Best Seller</span> <span class="info">in {{ scope.row.bsr }} ({{scope.row.bsr_date}})</span>
                        </div>
                        <div style="font-size: 12px; font-weight: 600;">小类排名：
                            <span v-if="scope.row.small_category_name">{{ scope.row.small_category_name }} </span>
                            <span v-if="scope.row.small_category_rank">({{scope.row.small_category_rank}})</span>
                            <span v-if="scope.row.small_category_date">【{{scope.row.small_category_date}}】</span>
                        </div>

                    </div>
                </template>
            </el-table-column>

            <el-table-column width="200" align="center" label="品名">
                <template slot-scope="scope">
                    <span>{{ scope.row.product_name }}</span>
                    <div>
                        铺货: {{ scope.row.is_launch == 1 ? '是' : '否' }} <br/>
                        主卖色: {{ scope.row.is_main_seller == 1 ? '是' : '否' }} <br/>
                        首单日期: {{ scope.row.first_order_time || '-' }} <br/>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="FBA库存" width="200" align="center" class="zoom">
                <template slot-scope="scope">
                    <div @click="showFbaModal(scope.row.fba_datas || [])">
                        可售：{{ scope.row.fba_sale_quantity }}<br/>
                        <span v-show="scope.row.maxSale">{{ scope.row.maxSale }}</span> <br/>
                        在途：{{ scope.row.fba_transit_quantity }}<br/>
                        <span v-show="scope.row.maxTransit">{{ scope.row.maxTransit }}</span> <br/>
                        <div v-show="scope.row.showShoppingArr.length > 0">
                            购物车<br/>
                            <div v-for="(item, index) in scope.row.showShoppingArr" :key="index">{{item.shopname}}</div>
                        </div>
                        海外仓库存：{{ scope.row.oversea_inventory_valid_num }} <br/>
                        海外仓在途：{{ scope.row.oversea_inventory_onway_num }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="利润" min-width="220" align="center">
                <template slot-scope="scope">
                    <div @click="previewProfit(scope.row)" class="zoom">
                        <span :style="{color: (scope.row.early_profit || 0) < 0 ? 'red': 'black'}">含税：{{ scope.row.early_profit }}</span><br/>
                        免税：{{ scope.row.early_profit_no_tax }}<br/>
                        <span :style="{color: accMul(scope.row['profit_rate'], 100) < 0 ? 'red': 'black'}">利润率(含税)：{{
                                scope.row['profit_rate'] ? accMul(scope.row['profit_rate'], 100) + '%' : '-'
                            }}</span>
                        <br/>

                        利润率(免税)：{{
                        scope.row['profit_rate_no_tax'] ? accMul(scope.row['profit_rate_no_tax'], 100) + '%' : '-'
                        }}<br/>
                        亚马逊物流配送费: {{ scope.row.delivery_charge }} <br/>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="毛利润(¥)" min-width="220" align="center">
                <template slot-scope="scope">
                    <div>
                        7日毛利润：{{ scope.row.gross_profit_7_days }} <br/>
                        <div class="smallTxt">{{ sevenDaysRange }}</div>

                        14日毛利润：{{ scope.row.gross_profit_14_days }} <br/>
                        <div class="smallTxt">{{ fourteenDaysRange }}</div>

                        30日毛利润：{{ scope.row.gross_profit_30_days }}
                        <div class="smallTxt">{{ thirtyDaysRange }}</div>

                    </div>
                </template>
            </el-table-column>

            <el-table-column label="销量" min-width="220" align="center">
                <template slot-scope="scope">
                    <div>
                        7日销量：{{ scope.row.sales_7_days }} <br/>
                        <div class="smallTxt">{{ sevenDaysRange }}</div>

                        14日销量：{{ scope.row.sales_14_days }} <br/>
                        <div class="smallTxt">{{ fourteenDaysRange }}</div>

                        <span :style="{color: (scope.row.sales_30_days || 0) < 30 ? 'red': 'black'}">30日销量：{{ scope.row.sales_30_days }}</span>
                        <div class="smallTxt">{{ thirtyDaysRange }}</div>

                    </div>
                </template>
            </el-table-column>

            <el-table-column label="花费(¥)-广告销量(广告Acos)" min-width="320" align="center">
                <template slot-scope="scope">
                    <div>
                        7日花费：{{ scope.row.spend_7_days }} - {{ scope.row.ad_volume_7_days }}
                        <span v-if="scope.row['acos_7_days']">({{ accMul(scope.row['acos_7_days'], 100) + '%' }})</span>
                        <br/>
                        <div class="smallTxt">{{ sevenDaysRange }}</div>
                        14日花费：{{ scope.row.spend_14_days }} - {{ scope.row.ad_volume_14_days }}
                        <span
                                v-if="scope.row['acos_14_days']">({{ accMul(scope.row['acos_14_days'], 100) + '%' }})</span>
                        <br/>
                        <div class="smallTxt">{{ fourteenDaysRange }}</div>
                        30日花费：{{ scope.row.spend_30_days }} - {{ scope.row.ad_volume_30_days }}
                        <span
                                v-if="scope.row['acos_30_days']">({{ accMul(scope.row['acos_30_days'], 100) + '%' }})</span>
                        <br/>
                        <div class="smallTxt">{{ thirtyDaysRange }}</div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="Teambition" width="150" align="center">
                <template slot-scope="scope">
                    <div v-show="scope.row.tfs_name" style="color:green;font-weight:900;letter-spacing: 2px;">
                        {{ scope.row.tfs_name }}
                    </div>
                    <div v-show="scope.row.teambition_url" @click="jumpUrl(scope.row.teambition_url)"
                         style="color:blue;cursor: pointer;">任务详情
                    </div>
                    <el-button size="mini" @click="updateTeambition(scope.row)">{{scope.row.collate_teambition ?
                        scope.row.collate_teambition : '未核对'}}
                    </el-button>

                </template>
            </el-table-column>

            <el-table-column label="Acos" width="220" align="center">
                <template slot-scope="scope">

                    <el-row :gutter="20">
                        <el-col :span="8">
                            <div class="grid-content bg-purple">-</div>
                        </el-col>
                        <el-col :span="8">
                            <div class="grid-content bg-purple">七天Acos</div>
                        </el-col>
                        <el-col :span="8">
                            <div class="grid-content bg-purple">目标Acos</div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <div class="grid-content bg-purple">Auto</div>
                        </el-col>
                        <el-col :span="8">
                            <div class="grid-content bg-purple">
                                <span style="color:#00af55;">
                                    {{ scope.row['auto_spend_acos'] ? scope.row['auto_spend_acos'] : '-' }}
                                </span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="grid-content bg-purple">

         <span class="hasStyle" @click="updateAcos(scope.row)" v-if="scope.row['set_profit_rate_no_tax']">{{
                 accMul(scope.row['set_profit_rate_no_tax'], 100) + '%'
             }}</span>
                                <span v-else style="color:#00af55; cursor: pointer;" @click="updateAcos(scope.row)">
                        {{ scope.row['profit_rate_no_tax'] ? accMul(scope.row['profit_rate_no_tax'], 100) + '%' : '-' }}
                    </span>

                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <div class="grid-content bg-purple">Skag</div>
                        </el-col>
                        <el-col :span="8">
                            <div class="grid-content bg-purple">
                                <span style="color:#00af55;">
                                    {{ scope.row['skag_spend_acos'] ? scope.row['skag_spend_acos'] : '-' }}
                                </span>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="grid-content bg-purple">
                   <span class="hasStyle" @click="updateSkag(scope.row)" v-if="scope.row.set_profit_rate_no_tax_skag">{{
                           accMul(scope.row['set_profit_rate_no_tax_skag'], 100) + '%'
                       }}</span>
                                <span v-else style="color:#00af55; cursor: pointer;" @click="updateSkag(scope.row)">
                        {{ scope.row['profit_rate_no_tax'] ? accMul(scope.row['profit_rate_no_tax'], 100) + '%' : '-' }}
                    </span>
                            </div>
                        </el-col>
                    </el-row>

                </template>
            </el-table-column>

            <check-info/>

            <el-table-column label="发货方式" min-width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.deliver_mode }}</div>
                </template>
            </el-table-column>


            <el-table-column label="广告情况" width="220" align="center">
                <template slot-scope="scope">
                    <div v-show="scope.row.ad_shopname && scope.row.ad_shopname !== ''">
                        <div class="basicInfo">店铺：{{ scope.row.ad_shopname }}</div>
                        <div class="basicInfo">Asin：{{ scope.row.ad_asin }}</div>
                        <div class="basicInfo">MSKU：{{ scope.row.ad_msku }}</div>
                        <div class="basicInfo">品名：{{ scope.row.ad_product_name }}</div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="已开广告组" align="center" :show-overflow-tooltip="true" width="130">
                <template slot-scope="scope">
                    <span @click="openListModal(scope.row.had_ads)">
                        <span :style="{'color': (scope.row.filterArr.length === (scope.row.had_ads || []).length ) ? 'green': 'red'}">
                            {{scope.row.filterArr.length}}</span>/
                        <span style="color: green">{{ (scope.row.had_ads || []).length }}</span>
                    </span>
                </template>
            </el-table-column>

            <el-table-column label="专利" min-width="120" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini">{{ scope.row.patent_value ? scope.row.patent_value : '-' }}
                    </el-button>
                    <br/><br/>
                    <el-button type="success" @click="downFile(scope.row.patent_file)" size="mini"
                               :disabled="!scope.row.patent_file">下载
                    </el-button>
                </template>
            </el-table-column>

            <el-table-column label="备注" align="center" :show-overflow-tooltip="true" width="220">
                <template slot-scope="scope">
                    <span>{{ scope.row.remark }}</span>
                </template>
            </el-table-column>

            <el-table-column label="规格包装" width="140" align="center">
                <template slot-scope="scope">
                    <el-button type="success" size="mini" @click="updateSpecificationPackage(scope.row)">查看</el-button>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="370" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button style="margin: 5px 0 5px 10px" type="success" size="mini" @click="updateFunc(scope.row)">
                        核对
                    </el-button>

                    <el-button style="margin: 5px 0 5px 10px" type="warning" size="mini"
                               @click="showInner(2, scope.row)">
                        修改asin
                    </el-button>

                    <el-button style="margin: 5px 0 5px 10px" type="danger" size="mini"
                               @click="noActiveList(scope.row)">
                        不再运营
                    </el-button>

                    <el-button type="primary" size="mini" @click="otherNationCreate(scope.row)">
                        他国创建
                    </el-button>

                    <el-button type="warning" size="mini" @click="synchronizationFunc(scope.row)">同步低价商城</el-button>

                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="未完成任务" :visible.sync="noFinishDialogVisible" width="700px" append-to-body>
            <el-table :data="noFinishList" size="mini" border>
                <el-table-column label="类型" prop="parent_task_content" min-width="220"/>
                <el-table-column label="内容" prop="content" min-width="320"/>
                <el-table-column label="详情" width="100" align="center">
                    <template slot-scope="scope">
                        <span style="color: #409EFF; cursor: pointer" @click="openTeambition(scope.row.teambition_url)" v-if="scope.row.teambition_url">详情</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :page-size="query.limit" :current-page="query.page"
                       :page-sizes="[20, 50, 100]" :total="query.total" background
                       style="float: right;margin-top: 10px;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>
        <item-info ref="itemInfo" @close-callback="closeCllback"></item-info>
        <uploadDom :visible="addSubLibraryModal" @close-callback="closeCllback"
                   title="上传"/>
        <car-modal ref="card" @close-callback="closeCllback"></car-modal>
        <fba-modal ref="fbaModal" @close-callback="closeCllback"></fba-modal>
        <open-list-modal ref="openListModal"></open-list-modal>
        <autoOptimizeDialog
                ref="autoOptimizeRef"
                :visible="ctrl.autoOptimizeVisible"
                :title="ctrl.dialogTitle"
                @close-callback="closeCllback"
        ></autoOptimizeDialog>
        <el-dialog
                title="提示" :visible.sync="noDialogVisible" width="30%" :before-close="noHandleCloseModal"
                append-to-body>
            <span style="margin-bottom: 20px">确认不再运营吗？</span>

            <el-form>
                <el-form-item label="不再运营原因:" class="query-form-item">
                    <el-input style="width: 170px;" clearable v-model="fail_reason" placeholder="请输入不再运营原因"
                              size="mini"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="noHandleCloseModal" size="mini">取 消</el-button>
                <el-button type="primary" @click="noOfficialOperation" size="mini">确 定</el-button>
              </span>
        </el-dialog>

        <el-dialog
                width="30%"
                title="修改运营ASIN"
                :visible.sync="innerModal.visible"
                :before-close="closeInner"
                append-to-body>
            <el-form ref="formData" :model="query" :inline="true" size="mini">
                <el-form-item label="运营ASIN:" class="query-form-item" prop="operator_asin">
                    <el-input style="width: 150px;" clearable v-model="operator_asin" placeholder="请输入运营ASIN"
                              size="mini"></el-input>
                </el-form-item>
            </el-form>

            <el-row style="margin-top:17px; ">
                <el-button style="float:right;margin-left:6px;" size="mini" type="primary" plain
                           v-show="innerModal.type==2" @click="updateAsinFunc()" :loading="updateAsinLoading">修 改
                </el-button>
            </el-row>
        </el-dialog>
        <updateAcosDom ref="updateAcosRef" @close-callback="closeCllback"></updateAcosDom>
        <updateSkagDom ref="updateSkagRef" @close-callback="closeCllback"/>
        <otherNation ref="otherNationModal" @close-callback="closeCllback"></otherNation>
        <export-dialog ref="exportDialogRef"/>
        <synchronization-dialog ref="synchronizationDialogRef"
                                @close-callback="closeCllback"></synchronization-dialog>
        <specification-package-modal ref="specificationPackageModal"
                                     @close-callback="closeCllback"></specification-package-modal>
    </div>
</template>

<script>
    import * as api from '@/api/advAnalys/advAnalys.js'
    import {downloadFileUrl} from '@/utils/method'
    import ItemInfo from './depend/itemInfo'
    import uploadDom from './depend/upload'
    import carModal from './depend/carModal'
    import fbaModal from './depend/fbaModal'
    import openListModal from './depend/openListModal'
    import updateAcosDom from './depend/updateAcos'
    import updateSkagDom from './depend/updateSkag'
    import autoOptimizeDialog from './depend/autoOptimizeDialog.vue'
    import otherNation from './depend/otherNation.vue'
    import ExportDialog from '@/views/costAnalysisOne/exportDialog.vue'
    import CheckInfo from '@/components/common/checkInfo.vue'
    import synchronizationDialog from '@/views/costAnalysisOne/synchronizationDialog.vue'
    import SpecificationPackageModal from './depend/specificationPackageModal.vue'

    export default {
        computed: {
            showDistributionPeople() {
                return this.$checkPermission('admin/operating_asin_manager/optimize_acos_excel_list/ui')
            },
        },
        components: {
            SpecificationPackageModal,
            synchronizationDialog,
            CheckInfo,
            ExportDialog,
            otherNation,
            autoOptimizeDialog,
            ItemInfo,
            uploadDom,
            carModal,
            fbaModal,
            openListModal,
            updateAcosDom,
            updateSkagDom
        },
        data() {
            return {
                sevenDaysRange: '',
                fourteenDaysRange: '',
                thirtyDaysRange: '',
                operatingList: '',
                operator_asin: '',
                rules: {
                    operator_asin: [{required: true, message: '请输入运营ASIN', trigger: 'blur'},]
                },
                innerModal: {
                    visible: false,
                    selInfo: {},
                    type: 1,
                },
                fail_reason: '',
                tempDate: {},
                noDialogVisible: false,
                updateAsinLoading: false,

                recheckLoading: false,
                vineStatusArr: [
                    {name: '全部', value: ''},
                    {name: '未申请', value: '未申请'},
                    {name: '申请中', value: '申请中'},
                    {name: '完成', value: '完成'},
                    {name: '老品', value: '老品'},
                ],
                standardProductTypeArr: [
                    {name: '全部', value: ''},
                    {name: '未录入', value: -1},
                    {name: '标品-大众', value: '标品-大众'},
                    {name: '标品-小众', value: '标品-小众'},
                    {name: '非标-大众', value: '非标-大众'},
                    {name: '非标-小众', value: '非标-小众'},
                ],
                fbaCollateArr: [
                    {name: '全部', value: ''},
                    {name: '待核对', value: 0},
                    {name: '已核对', value: 1},
                    {name: '核对有误', value: -1},
                ],
                collateArr: [
                    {name: '全部', value: ''},
                    {name: '已核对', value: 1},
                    {name: '未核对', value: 0},
                ],
                isLowPrice: [
                    {name: '全部', value: ''},
                    {name: '是', value: 1},
                    {name: '否', value: 0},
                ],
                selectionPrincipleList: [],
                addSubLibraryModal: false,

                editType: 0,
                manualRootShow: false,
                tableHeight: null,
                managerAnalysisList: [],
                teambitionList: {},
                smallBestseller: [
                    {name: '不是小爆款', value: 0},
                    {name: '是小爆款', value: -1},
                    {name: '小爆款-自然单', value: 1},
                    {name: '小爆款-低花费Acos', value: 2},
                ],
                query: {
                    page: 1,
                    limit: 20,
                    total: 0,
                },

                list: [],
                disabled: false,
                loading: false,
                ctrl: {
                    dialogTitle: '',
                    autoOptimizeVisible: false,
                },
                noFinishDialogVisible: false,
                noFinishList: [],
            }
        },
        created() {
            this.getManagerAnalysisList()
        },
        mounted() {
            this.tableHeight =
                window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
            const that = this
            window.onresize = () => {
                return (() => {
                    if (typeof that.$refs.form == 'object') {
                        that.tableHeight =
                            window.innerHeight -
                            140 -
                            that.$refs.form.$el.offsetHeight
                    }
                })()
            }
            this.getList()
            this.getTeambitionList()
            this.setDateRanges()

        },
        beforeDestroy() {
        },
        watch: {
            tableHeight(val) {
                this.tableHeight = val
            }
        },
        methods: {
            jumpAmazonByState(data) {
                let url = ''
                const state = (data.state || '').toLowerCase()
                switch (state) {
                    case 'us':
                        url = 'https://www.amazon.com/dp/' + data.asin
                        break
                    case 'uk':
                        url = 'https://www.amazon.co.uk/dp/' + data.asin
                        break
                    case 'de':
                        url = 'https://www.amazon.de/dp/' + data.asin
                        break
                    case 'fr':
                        url = 'https://www.amazon.fr/dp/' + data.asin
                        break
                    case 'it':
                        url = 'https://www.amazon.it/dp/' + data.asin
                        break
                    case 'es':
                        url = 'https://www.amazon.es/dp/' + data.asin
                        break
                    case 'ca':
                        url = 'https://www.amazon.ca/dp/' + data.asin
                        break
                    case 'mx':
                        url = 'https://www.amazon.mx/dp/' + data.asin
                        break
                    case 'br':
                        url = 'https://www.amazon.br/dp/' + data.asin
                        break
                    case 'nl':
                        url = 'https://www.amazon.nl/dp/' + data.asin
                        break
                    case 'se':
                        url = 'https://www.amazon.se/dp/' + data.asin
                        break
                    case 'pl':
                        url = 'https://www.amazon.pl/dp/' + data.asin
                        break
                    case 'be':
                        url = 'https://www.amazon.be/dp/' + data.asin
                        break
                    case 'tr':
                        url = 'https://www.amazon.tr/dp/' + data.asin
                        break
                }
                if (url) {
                    window.open(url, '_blank')
                }
            },
            openTeambition(url) {
                if (!url) return
                window.open(url, '_blank')
            },
            openNoFinishDialog(list) {
                console.log('list', list)
                this.noFinishList = list || []
                this.noFinishDialogVisible = true
            },
            changeNullRating() {
                console.log('this.query.null_rating', this.query.null_rating)
                if (this.query.null_rating) {
                    this.query.min_rating = undefined
                    this.query.max_rating = undefined
                }
            },
            getCurrentDateFormatted() {
                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以+1
                const day = String(now.getDate()).padStart(2, '0');

                return `${year}-${month}-${day}`;
            },
            updateTeambition(data) {
                this.$confirm(`是否确认核对?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.operating_asin_manager_index_update_field({
                            id: data.id, collate_teambition: this.getCurrentDateFormatted()
                        }
                    ).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '核对成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })
            },
            synchronizationFunc(data) {
                this.$refs.synchronizationDialogRef.openModal(data, 2)
            },
            formatDate(date) {
                return date.toISOString().split('T')[0] // 格式化日期为 "YYYY-MM-DD"
            },
            setDateRanges() {
                const today = new Date()
                const yesterday = new Date(today)
                yesterday.setDate(today.getDate() - 1) // 昨天的日期

                // 7日内
                const sevenDaysAgo = new Date(yesterday)
                sevenDaysAgo.setDate(yesterday.getDate() - 6) // 7天前的日期

                // 14日内
                const fourteenDaysAgo = new Date(yesterday)
                fourteenDaysAgo.setDate(yesterday.getDate() - 13) // 14天前的日期

                // 30日内
                const thirtyDaysAgo = new Date(yesterday)
                thirtyDaysAgo.setDate(yesterday.getDate() - 29) // 30天前的日期

                // 格式化并赋值给data
                this.sevenDaysRange = `${this.formatDate(sevenDaysAgo)} - ${this.formatDate(yesterday)}`
                this.fourteenDaysRange = `${this.formatDate(fourteenDaysAgo)} - ${this.formatDate(yesterday)}`
                this.thirtyDaysRange = `${this.formatDate(thirtyDaysAgo)} - ${this.formatDate(yesterday)}`
            },
            getTeambitionList() {
                api.cost_analysis_selfbuild_get_selection_principle().then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        this.selectionPrincipleList = (res.data || []).map(item => {
                            return {name: item, value: item}
                        })
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).catch(() => {
                    this.loading = false
                })

                api.get_tfs_name_lists().then((res) => {
                    if (res.success) {
                        this.teambitionList = res.data
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                })
            },
            adjustNumber(num) {
                // 获取整数部分
                let integerPart = Math.floor(num)
                // 使用toFixed(1)来获取一位小数，并转换为数字以避免精度问题
                let decimalPart = Number(((num - integerPart).toFixed(1)))
                if (decimalPart >= 0 && decimalPart < 0.3) {
                    return integerPart
                } else if (decimalPart >= 0.3 && decimalPart < 0.8) {
                    return integerPart + 0.5
                } else if (decimalPart >= 0.8 && decimalPart < 1) {
                    return integerPart + 1
                } else {
                    // 如果小数部分不在上述范围内，返回原数字
                    return num
                }
            },
            //Auto优化
            autoOptimize() {
                this.ctrl.dialogTitle = 'Acos优化'
                this.ctrl.autoOptimizeVisible = true
                this.$refs.autoOptimizeRef.getList()
            },
            resetFirstTime(data) {
                this.$confirm('是否重置时间?', '提示', {type: 'warning'}).then(() => {
                    api.operating_asin_manager_index_update_field({
                        id: data.id,
                        fba_first_sale_time: 'reset'
                    }).then((res) => {
                        if (res.success) {
                            this.$message.success('重置成功')
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    })
                })
            },
            updateAcos(data) {
                this.$refs.updateAcosRef.openModal(data)
            },
            updateSkag(data) {
                this.$refs.updateSkagRef.openModal(data)
            },
            exportFunc() {
                this.$refs.exportDialogRef.openModal(this.query, 1)

                // api.operating_asin_manager_index_export_operating_asin_list().then((res) => {
                //     if (res.success) {
                //         this.downFile(res.data)
                //     } else {
                //         this.$message({
                //             type: 'error',
                //             message: res.message
                //         })
                //     }
                // })
            },
            openListModal(data) {
                if ((data || []).length > 0) {
                    this.$refs.openListModal.openModal(data)
                }
            },
            updateAsinFunc() {
                this.updateAsinLoading = true
                api.operation_index_update_operator_asin({
                    id: this.innerModal.selInfo.id,
                    operator_asin: this.operator_asin
                }).then(res => {
                    if (res.code === 0) {
                        this.$message({message: '修改成功', type: 'success'})
                        this.closeInner()
                        this.getList()
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).finally(() => {
                    this.updateAsinLoading = false
                })
            },
            noOfficialOperation() {
                let func = () => {
                    api.operation_index_update_operation_status_to_fail({
                        id: this.tempDate.id,
                        fail_reason: this.fail_reason
                    }).then((res) => {
                        if (res.success) {
                            this.$message.success('操作成功')
                            this.fail_reason = ''
                            this.noDialogVisible = false
                            this.getList()
                        } else {
                            this.$message.error(res.message)
                        }
                    }).catch(() => {
                        this.noDialogVisible = false
                    })
                }
                func()
            },
            noHandleCloseModal() {
                this.fail_reason = ''
                this.noDialogVisible = false
            },
            showInner(typeNum, selInfo) {
                this.innerModal.type = typeNum
                this.innerModal.visible = true
                if (typeNum === 2) {
                    let info = JSON.parse(JSON.stringify(selInfo))
                    this.operator_asin = info.asin
                    this.innerModal.selInfo = info
                }
            },
            closeInner() {
                this.innerModal.visible = false
                this.operator_asin = ''
                this.query.status = 1
            },
            noActiveList(data) {
                this.tempDate = data
                this.noDialogVisible = true
            },
            otherNationCreate(data) {
                this.$refs.otherNationModal.openModal(data)
            },
            recheck(data) {
                this.recheckLoading = true
                api.operating_asin_manager_index_recalibrate_fba_charge({id: data.id}).then(res => {
                    if (res.success) {
                        this.$message.success('核对成功')
                        this.getList()
                    } else {
                        this.$notify({title: '提示', message: res.message, duration: 5000})
                    }
                }).finally(() => {
                    this.recheckLoading = false
                })
            },
            showFbaModal(arr) {
                if (arr.length > 0) {
                    this.$refs.fbaModal.showModal(arr)
                }
            },
            previewProfit(data) {
                api.operating_asin_manager_index_get_cost_analysis_data({id: data.id}).then(res => {
                    if (res.success) {
                        let resData = res.data
                        resData.refund_rate = this.accMul(resData.refund_rate, 100)
                        this.$refs.card.showModal(resData, JSON.parse(JSON.stringify(data)))
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                })
            },
            getManagerAnalysisList() {
                api.manager_index_get_operator_list().then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        const responseList = res.data || []
                        this.managerAnalysisList = responseList
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                }).catch(() => {
                    this.loading = false
                })
            },
            jumpUrl(url) {
                window.open(url, '_blank')
            },
            uploadFunc() {
                this.addSubLibraryModal = true
            },
            closeCllback(refresh) {
                this.addSubLibraryModal = false
                this.ctrl.autoOptimizeVisible = false
                refresh == true && this.getList()
            },
            updateSpecificationPackage(data) {
                this.$refs.specificationPackageModal.openModal(data)
            },
            updateFunc(data) {
                this.$refs.itemInfo.openModal(3, JSON.parse(JSON.stringify(data)))
            },
            delete_records(data) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.branch_warehouse_manager_delete({id: data.id}).then(() => {
                        this.$message.success('删除成功')
                        this.getList()
                    })
                })
            },
            getUpdateStatus(data) {
                api.branch_warehouse_line_get_update_status({id: data.id}).then((res) => {
                    const h = this.$createElement
                    this.$notify({
                        title: '提示',
                        message: h('i', {style: 'color: teal'}, res.data || ''),
                        duration: 5000
                    })
                }).catch(res => {
                    this.$message({type: 'error', message: res.message})
                })
            },
            getPeaple_records(data) {
                this.subLibraryDetailInfo = data
                this.peopleListVisible = true
            },
            showErrorInfo(info) {
                this.errorInfoShow = true
                this.errorMsg = info.alibaba_err_msg
            },
            showManualRoot(info) {
                this.manualRootShow = true
                this.manualRootList = info
            },
            getList() {
                this.loading = true
                const tempQuery = this.$refs.formRangeItem.handleQueryData()
                if (tempQuery.null_rating) {
                    tempQuery.min_rating = undefined
                    tempQuery.max_rating = undefined
                    tempQuery.null_rating = 1
                } else {
                    tempQuery.null_rating = undefined
                }

                api.operating_asin_manager_index_operating_asin_list(tempQuery).then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        const responseList = (res.data.list || []).map(item => {
                            let maxSale = ''
                            let maxTransit = ''
                            let showShoppingArr = []
                            if (item.fba_datas && item.fba_datas.length > 0) {
                                let sortSale = (item.fba_datas || []).sort((a, b) => b.fba_sale_quantity - a.fba_sale_quantity)
                                maxSale = sortSale[0].shopname
                                let sortTransit = (item.fba_datas || []).sort((a, b) => b.fba_transit_quantity - a.fba_transit_quantity)
                                maxTransit = sortTransit[0].shopname
                                showShoppingArr = item.fba_datas.filter(item=>item.in_shopping===1)
                            }
                            item.filterArr = (item.had_ads || []).filter(item => item.in_shopping)
                            item.maxSale = maxSale
                            item.maxTransit = maxTransit
                            item.showShoppingArr = showShoppingArr
                            item.ratingNum = this.adjustNumber(item.rating || 0)
                            console.log('item.ratingNum', item.ratingNum, item.rating)
                            return item
                        })
                        this.list = responseList
                        this.query.total = res.data.total
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                }).catch(() => {
                    this.loading = false
                })
            },
            clickRowHandle(row, column) {
                if (['标题', '类目树', '子类目', '颜色'].includes(column.label)) {
                    this.childInfo.title = column.label
                    let info = row.title
                    if (column.label == '类目树') {
                        info = row.categoryTree
                    } else if (column.label == '子类目') {
                        info = row.categories_str
                    } else if (column.label == '颜色') {
                        info = row.color
                    }
                    this.childInfo.info = info
                    this.ctrl.childInfoVisible = true
                }
                if (['折叠', '收起'].includes(column.label)) {
                    this.isFold = !this.isFold
                }
            },
            clickHeaderHandle(row, column) {
                if (['折叠', '收起'].includes(row.label)) {
                    this.isFold = !this.isFold
                }
            },
            handleSortChange(val) {
                if (val.order == 'ascending') {
                    this.query.desc = 'desc'
                    this.query.order = val.prop
                } else if (val.order == 'descending') {
                    this.query.desc = 'asc'
                    this.query.order = val.prop
                }
                this.getList()
            },
            handleClick(tab) {
                this.$nextTick(() => {
                    this.$refs[tab.paneName].getList()
                })
            },
            //重置
            onReset() {
                this.query = {
                    state: '',
                    asin: '',
                    product_name: '',
                    standard_product_type: '',
                    check_fba_charge: '',
                    check_packing: '',
                    is_market_lowest_price: '',
                    vine_status: '',
                    operation_id: '',

                    page: 1,
                    limit: 20,
                    total: 0,
                }
                this.getList()
            },
            //查询
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
            basicData() {
                this.showBasicConfigDataModal = true
            },
            addParse() {
                this.showAddParseModal = true
            },
            // 批量删除
            batchDelete() {
                if (this.multipleSelection.length > 0) {
                    this.$confirm(`确定批量删除已选择项吗?`, {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        api.variety_cost_control_analysis_delete({ids: this.multipleSelection}).then(res => {
                            if (res.code === 0) {
                                this.$message({type: 'success', message: '删除成功'})
                                this.getList()
                            } else {
                                this.$message({type: 'error', message: res.message})
                            }
                        }).catch(res => {
                            this.$message({type: 'error', message: res.message})
                        })
                    }).catch(() => {
                    })

                } else {
                    this.$message.info('暂未选择批量处理内容')
                }
            },
            // 批量重置
            batchReset() {
                if (this.multipleSelection.length > 0) {
                    this.$confirm(`确定批量重置已选择项吗?`, {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        api.variety_cost_control_analysis_batch_reset({ids: this.multipleSelection}).then(res => {
                            if (res.code === 0) {
                                this.$message({type: 'success', message: '重置成功'})
                                this.getList()
                            } else {
                                this.$message({type: 'error', message: res.message})
                            }
                        }).catch(res => {
                            this.$message({type: 'error', message: res.message})
                        })
                    }).catch(() => {
                    })

                } else {
                    this.$message.info('暂未选择批量处理内容')
                }
            },
            // 类目列表
            categoryList() {
                this.showCategoryList = true
            },
            upadteRanking() {
                this.upadteRankingModal = true
            },
            change() {
                this.getList()
            },
            clearValue() {
                this.query.state = ''
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            //上传文件
            onupload() {
                this.ctrl.uploadDialogVisible = true
            },
            //下载列表
            onDownloadList() {
                this.ctrl.DownloadListDialogVisible = true
                this.$nextTick(() => {
                    this.$refs[this.activeName].getList()
                })
            },
            /**
             * 数字相乘
             * @param {*} arg1
             * @param {*} arg2
             * @returns
             */
            accMul(arg1, arg2) {
                let m = 0
                m = this.accAdd(m, this.getDecimalLength(arg1))
                m = this.accAdd(m, this.getDecimalLength(arg2))
                return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
            },
            getNum(arg = '') {
                return Number((arg || "").toString().replace('.', ''))
            },
            getDecimalLength(arg = '') {
                try {
                    return arg.toString().split('.')[1].length
                } catch (e) {
                    return 0
                }
            },
            changeNum(arg1 = '', arg2 = '', isAdd = true) {
                const changeInteger = (arg, r, maxR) => {
                    if (r != maxR) {
                        let addZero = ''
                        for (let i = 0; i < maxR - r; i++) {
                            addZero += '0'
                        }
                        arg = Number(arg.toString().replace('.', '') + addZero)
                    } else {
                        arg = this.getNum(arg)
                    }
                    return arg
                }

                let r1, r2, maxR, m
                r1 = this.getDecimalLength(arg1)
                r2 = this.getDecimalLength(arg2)
                maxR = Math.max(r1, r2)
                arg1 = changeInteger(arg1, r1, maxR)
                arg2 = changeInteger(arg2, r2, maxR)
                m = Math.pow(10, maxR)
                if (isAdd) {
                    return (arg1 + arg2) / m
                } else {
                    return (arg1 - arg2) / m
                }
            },

            /**
             * 数字相加
             * @param {*} arg1
             * @param {*} arg2
             * @returns
             */
            accAdd(arg1, arg2) {
                return this.changeNum(arg1, arg2)
            },
            // bid记录列表
            openBidList(data) {
                this.currentId = data.id
                this.ctrl.bidDialogVisible = true
            },
            async startDecode(row, force = 0) {
                if (force) {
                    await this.$confirm('是否重新运行解析任务', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                }
                let list = JSON.parse(JSON.stringify(this.list))
                api.variety_cost_control_analysis_parsing_file({
                    id: row.id,
                    force
                }).then(() => {
                    const index = list.findIndex(item => item.id === row.id)
                    list[index].status = 1
                    this.list = list
                })
            },
            downFile(path) {
                if (!path) {
                    return this.$message({
                        type: 'error',
                        message: '无法下载！'
                    })
                }
                downloadFileUrl(path)
            },
            //添加广告优化记录
            onAddPpc(data) {
                this.record_id = data.id
                this.ctrl.addPpcDialogVisible = true
            },
            goBackList() {
                this.showPageType = 0
            },
            update(data) {
                this.updateData = data
                this.showAddRecord = true
            }
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>

    .hasStyle {
        color: blue;
        text-decoration: underline;
        cursor: pointer;
    }

    .zoom {
        cursor: pointer; /* 改变鼠标指针为手指形状 */
    }

    .zoom:hover {
        cursor: zoom-in; /* 鼠标悬停时变成放大镜图标 */
    }

    .basicInfo {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 5px;
    }

    .redClass {
        color: red;
        font-weight: bold;
    }

    .greenClass {
        color: green;
        font-weight: bold;
    }

    .fixedHeight {
        height: 30px;
        line-height: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .mini_div .el-button--mini {
        padding: 5px 5px !important;
    }

    /deep/ .el-table__expanded-cell {
        padding: 0 0 !important;
    }

    /deep/ .el-form-item {
        margin-bottom: 8px !important;
    }

    .smallTxt {
        color: #cccccc;
        font-size: 11px;
    }

    .redBox {
        display: inline-block;
        padding: 0px 5px;
        border-radius: 5px;
        margin-right: 10px;
        color: white;
        background: rgba(194, 82, 34, 1);
    }

    .info {
        display: inline-block;
        color: rgba(50, 98, 156, 1);
        font-size: 16px;
    }

    .asinBox {
        position: relative;
        padding-top: 20px;

        .hotBox {
            position: absolute;
            right: -10px;
            top: 0;
            background: rgba(255, 0, 0, 0.2);
            padding: 0 8px;
            border-radius: 8px;
            cursor: pointer;
        }

        .no-finish-box {
            margin-top: 6px;
            font-size: 12px;
        }
    }
</style>
